import React, {useEffect, useRef } from 'react';
import Utils from '../utils';

function StringResult({ item, index, term, useRaw}) {
    const componentRef = useRef(null);
    
    useEffect(() => {
        // Run doCH for the current component only
        if (componentRef.current) {
          Utils.highlightSearchTerm(componentRef.current, term);
          Utils.doCH(componentRef.current);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []); // Empty dependency array ensures this runs only once after initial render

  return (
    <li className={`result-item ${item.outputLanguage2 ? `multi` : ``}`} data-id={item.id} key={index} ref={componentRef}>
        <ul className="info-container" data-id={item.id}>
            <li>
                <span>{item.id}</span>
            </li>
        </ul>
        <ul className="language-container" data-id={item.id}>
            <li>
                {useRaw ? (
                <span
                className={Utils.getDescClass(item.inputLanguage.string)}
                >{item.inputLanguage.string}</span>
                ) : (
                <span
                className={Utils.getDescClass(item.inputLanguage.string)}
                dangerouslySetInnerHTML={{
                    __html: Utils.doPreview(item.inputLanguage.string),
                }}
                ></span>
                )}
            </li>
        </ul>
        <ul className="language-container" data-id={item.id}>
            <li>
                {useRaw ? (
                    <span
                    className={Utils.getDescClass(item.outputLanguage.string)}
                    >{item.outputLanguage.string}</span>
                ) : (
                <span
                className={Utils.getDescClass(item.outputLanguage.string)}
                dangerouslySetInnerHTML={{
                    __html: Utils.doPreview(item.outputLanguage.string),
                }}
                ></span>
                )}
            </li>
        </ul>
        {/* Check if item has outputLanguage2 */}
        {item.outputLanguage2 ? (
            <ul className="language-container" data-id={item.id}>
            <li>
                {useRaw ? (
                    <span className={Utils.getDescClass(item.outputLanguage2.string)}>{item.outputLanguage2.string}</span>
                ) : (
                <span
                className={Utils.getDescClass(item.outputLanguage2.string)}
                dangerouslySetInnerHTML={{
                    __html: Utils.doPreview(item.outputLanguage2.string),
                }}
                ></span>
                )}
            </li>
        </ul>
        ): null}
    </li>
  );
}

export default StringResult;